<a
  class="med-link"
  routerLinkActive="active"
  [target]="target"
  [routerLink]="link"
  [ngClass]="classList"
>
  <ng-content></ng-content>
</a>
